// extracted by mini-css-extract-plugin
module.exports = {"headband":"_1XF_k","block":"_3Q5Q3","blockTitleLink":"nvlrA","blockProduct":"_3JvvB"};